import React, { Component, } from 'react';
import { Link } from "react-router-dom";
import {
    Button,
    Col,
    Divider,
    Icon,
    Row
} from 'antd';
import registerLogo from './images/footer-logo.png';

let baseUrl = window.location.origin
class Footer extends Component {
    render() {
        if (window.location.host.includes("localhost") || window.location.host.includes("beta") || window.location.host.includes("bfiledev")) {
            baseUrl = "https://beta.bfilesystem.com"
        }
        return (
            <React.Fragment>
                <Row gutter={16}>
                    <Col md={14}>
                        <img width={200} src={registerLogo} alt="B File" />
                    </Col>
                    <Col md={10}>
                        <Col md={12}>
                            <ul style={{ color: 'white', listStyle: 'none', padding: 0 }}>
                                <label>MENU</label>
                                <li><a href={`${baseUrl}/about-us/`} target="blank">About Us</a></li>
                                <li><a href={`${baseUrl}/the-system/`} target="blank">The System</a></li>
                                <li><a href={`${baseUrl}/pricing/`} target="blank">Pricing</a></li>
                                <li><a href={`${baseUrl}/security/`} target="blank">Security</a></li>
                                <li><a href={`${baseUrl}/sla/`} target="blank">SLA</a></li>
                                <li><a href={`${baseUrl}/contact-us/`} target="blank"><span style={{ color: "#43ade2" }}>Contact Us</span></a></li>
                            </ul>
                        </Col>
                        <Col md={12}>
                            <label>
                                PHONE
                            </label>
                            <h2> 586.580.0033</h2>
                            <label>
                                ADDRESS
                            </label>
                            <h3>
                                42524 Hayes Rd.
                                Suite 700
                                Clinton Twp, MI 48038
                            </h3>
                        </Col>
                    </Col>
                </Row>
                <Row style={{ textAlign: 'center' }}>
                    <p>All rights reserved. Developed by <a style={{ color: 'white' }} href="https://bmgmediaco.com" target="blank">BMG Media</a></p>
                </Row>
            </React.Fragment >
        );
    }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/scenes/Register/parts/footer.js